import formatPrice from '../formatPrice';

export const prettyPrice = (price, withSup = false) => {
  const formatted = formatPrice(price);

  if (!withSup) {
    return formatted;
  }

  return `${formatted.split(',')[0]},<sup>${formatted.split(',')[1]}</sup>`;
};

export const updateQuantity = (id, quantity) => $.ajax({
  url: `/cart-item/${id}`,
  method: 'POST',
  data: {
    _method: 'PUT',
    quantity,
  },
});
